// extracted by css-extract-rspack-plugin
export default {"MobileHamburgerIcon":"AdminNavbar-module__MobileHamburgerIcon___uGr0f"};